/*
  FEATURE MODULES | samostatné funkční celky
*/

// GALERIE | Obrázky, videa, ...
export const gallery = async () => {
  const galleryElement: HTMLDivElement | null = document.querySelector('[data-gallery-init]');

  if (galleryElement) {
    const Gallery = await import(
      /* webpackChunkName: 'default/chunk-gallery' */
      '@features/gallery/Gallery'
    );

    Gallery.default();
  }
};

// ENQUIRY | Anketa výsledky po přihlášení
export const enquiry = async () => {
  const enquiryElements: NodeListOf<HTMLButtonElement> = document.querySelectorAll('.enquiry-bars');

  if (enquiryElements && enquiryElements.length) {
    const { enquiryBars } = await import(
      /* webpackChunkName: 'default/chunk-enquiry' */
      '@box/article/EnquiryBars/enquiryBars'
    );

    enquiryBars(enquiryElements);
  }
};

// SURVEY | Anketa
export const survey = async () => {
  const elements: NodeListOf<HTMLButtonElement> = document.querySelectorAll('.survey');

  if (elements && elements.length) {
    const { survey } = await import(
      /* webpackChunkName: 'default/chunk-survey' */
      '../../box/article/Survey/survey'
    );

    survey(elements);
  }
};

// FÓRUM | Kompletní funkcionalita diskuzí
export const forum = async () => {
  const forumDiv: HTMLDivElement | null = document.querySelector('[data-forum]');

  if (forumDiv) {
    const Forum = await import(
      /* webpackChunkName: 'default/chunk-forum' */
      '@box/forum/Forum'
    );

    Forum.default();
  }
};

// LIST-ARTICLE | Asynchronní donačítání článků
export const loadMore = async () => {
  const loadMoreElements: NodeListOf<HTMLLinkElement> =
    document.querySelectorAll('[data-load-more]');

  if (loadMoreElements && loadMoreElements.length) {
    const { LoadMore } = await import(
      /* webpackChunkName: 'default/chunk-load-more' */
      '@boxIsport/listArticle/LoadMore/LoadMore'
    );

    LoadMore(loadMoreElements);
  }
};

// LIST-ARTICLE | Odkryvání přednačtených doporučených článků
export const uncoverBehavArticles = async () => {
  const uncoverBehavArticlesBtn = document.querySelector<HTMLLinkElement>('.uncover-btn');

  if (uncoverBehavArticlesBtn) {
    const { UncoverBehavArticles } = await import(
      /* webpackChunkName: 'default/chunk-uncover-behav-articles' */
      '@box/listArticle/UncoverBehavArticles'
    );

    UncoverBehavArticles();
  }
};

// REKLAMA | HALFPAGE REPEATER MANAGER
export const halfPageManager = async () => {
  const topAside: HTMLElement | null = document.querySelector(
    '[data-first-content] > aside:not(.no-repeaters)'
  );
  const bottomAside: HTMLElement | null = document.querySelector(
    '.main--second-content > aside:not(.no-repeaters)'
  );
  const footer: HTMLDivElement | null = document.querySelector('[data-footer-trigger-aside]');
  if ((topAside || bottomAside) && footer) {
    const HalfPageManager = await import(
      /* webpackChunkName: 'default/chunk-ads-repeater' */
      '@box/ads/HalfPageManager/HalfPageManager'
    );

    HalfPageManager.default();
  }
};

// NEWSLETTER
export const newsletter = async () => {
  const newsletters = document.querySelector<HTMLButtonElement>('.newsletters');

  if (newsletters) {
    const { Newsletter } = await import(
      /* webpackChunkName: 'default/newsletter' */
      '@boxIsport/newsletter'
    );

    Newsletter();
  }
};

// COMPANY SUBSCRIPTION
export const companySubscription = async () => {
  const CompanySubscriptionSelector = document.querySelector<HTMLElement>('.company-subscription');

  if (CompanySubscriptionSelector) {
    const { CompanySubscription } = await import(
      /* webpackChunkName: 'default/companySubscription' */
      '@box/companySubscription/companySubscription'
    );

    CompanySubscription();
  }
};

// SWIPER
export const swipers = async () => {
  const swiperSelectors = [...document.querySelectorAll('[data-swiper]')];

  if (swiperSelectors.length > 0) {
    const { Swiper } = await import(
      /* webpackChunkName: 'default/swiper' */
      '@featuresIsport/swiper'
    );

    for (const swiperSelector of swiperSelectors) {
      if (swiperSelector instanceof HTMLDivElement) {
        Swiper(swiperSelector);
      }
    }
  }
};

// things article swiper
export const thingsArticleSwiper = async () => {
  const swiperThoughts: HTMLTemplateElement | null = document.querySelector('[data-thoughts]');

  if (swiperThoughts) {
    const { ThoughtsScroll } = await import(
      /* webpackChunkName: 'default/thingsArticleSwiper' */
      '@features/thingsArticleSwiper'
    );

    ThoughtsScroll(swiperThoughts);
  }
};

export const editorialPromo = async () => {
  const editorialPromoMagazines = ['reflex', 'e15', 'zeny'];
  const domain = window.location.hostname;

  if (editorialPromoMagazines.some((magazine) => domain.includes(magazine))) {
    const { EditorialPromo } = await import(
      /* webpackChunkName: 'default/chunk-editorial-promo' */
      '@features/editorialPromo/EditorialPromo'
    );

    EditorialPromo();
  }
};

export const topicBanner = async () => {
  const topicBannerElement: HTMLTemplateElement | null =
    document.querySelector('[data-topic-banner]');

  if (topicBannerElement) {
    const { TopicBanner } = await import(
      /* webpackChunkName: 'default/topic-banner' */
      '@features/topicBanner'
    );
    TopicBanner(topicBannerElement);
  }
};

// INSTAGRAM
export const instagramBox = async () => {
  const instagramBoxSelectors = [...document.querySelectorAll('[data-ig-box]')];

  if (instagramBoxSelectors.length > 0) {
    const { InstagramBox } = await import(
      /* webpackChunkName: 'default/instagram' */
      '@features/instagram/instagramBox'
    );

    for (const instagramBoxSelector of instagramBoxSelectors) {
      if (instagramBoxSelector instanceof HTMLElement) {
        await InstagramBox(instagramBoxSelector);
      }
    }
  }
};

// piano predplatne links
export const successReturnUrlAttacher = async () => {
  const searchUrlParams = new URLSearchParams(window.location.search);
  const successReturnUrl = searchUrlParams.get('success_return_url');
  if (!successReturnUrl) return;

  let linkTargets = [
    ...document.querySelectorAll('a.piano-landingpage__offer__button'),
  ] as HTMLAnchorElement[];
  if (!linkTargets.length) return;

  linkTargets = linkTargets.splice(0, 2);

  const { SuccessReturnUrlAttacher } = await import(
    /* webpackChunkName: 'default/piano' */
    '@features/piano/index'
  );

  SuccessReturnUrlAttacher(successReturnUrl, linkTargets);
};

// Google One click Login Porta
export const portaInit = async () => {
  const isPortaInitEnabled =
    new URLSearchParams(window.location.search).get('PortaInit') === 'true';
  if (!isPortaInitEnabled) return;

  const userNotLogged: HTMLDivElement | null = document.querySelector('[data-user-not-logged]'); // Kontrolujeme, jestli uzivatel jestě neni prihlaseny.
  const isDesktopDevice: boolean = window.innerWidth > 1080;

  if (userNotLogged && isDesktopDevice) {
    const { PortaInit } = await import(
      /* webpackChunkName: 'default/portaInit' */
      '@features/porta/PortaInit'
    );

    await PortaInit();
  }
};

// JAKEBOX
export const jakeBox = async () => {
  const jakeBoxSelector = document.querySelector('[data-jakebox]');

  if (jakeBoxSelector) {
    const { JakeBox } = await import(
      /* webpackChunkName: 'default/jakebox' */
      '@features/jake/jakeBox'
    );

    if (jakeBoxSelector instanceof HTMLElement) {
      JakeBox(jakeBoxSelector);
    }
  }
};

// COLLAPSER
export const collapsers = async () => {
  const collapserSelectors: HTMLDivElement[] | [] = Array.from(
    document.querySelectorAll('[data-collapser]')
  );

  if (collapserSelectors.length > 0) {
    const { Collapser } = await import(
      /* webpackChunkName: 'default/collapser' */
      '@features/collapser'
    );

    for (const collapserSelector of collapserSelectors) {
      Collapser(collapserSelector);
    }
  }
};

// AUTHOR CARD LIST
export const authorCardList = async () => {
  const authorCardListSelector: HTMLDivElement | null =
    document.querySelector('[data-author-card-list]');

  if (authorCardListSelector) {
    const { AuthorCardList } = await import(
      /* webpackChunkName: 'default/author-card-list' */
      '@features/authorCardList'
    );

    AuthorCardList(authorCardListSelector);
  }
};

// AUDIO VERSION
export const audioVersion = async () => {
  const audioVersionSelector: HTMLDivElement | null = document.querySelector(
    '[data-audio-version-player]'
  );
  if (audioVersionSelector) {
    const { AudioVersion } = await import(
      /* webpackChunkName: 'default/audio-version' */
      '@features/audioVersion'
    );

    AudioVersion(audioVersionSelector);
  }
};

// Rename article list for io analytics and Marfeel

export const renameArticleList = async () => {
  const renameArticleListSelectors: HTMLDivElement[] = Array.from([
    ...document.querySelectorAll('[data-vr-zone="List articles"]'),
  ]).filter((el): el is HTMLDivElement => el instanceof HTMLDivElement);

  if (renameArticleListSelectors.length > 0) {
    const { RenameArticleList } = await import(
      /* webpackChunkName: 'default/rename-article-list' */
      '@features/renameArticleList'
    );

    RenameArticleList();
  }
};

export const todayResultSliderHP = async () => {
  const sliderElement: HTMLDivElement | null = document.querySelector('.today-results');

  if (sliderElement) {
    const { todayResultsSlider } = await import(
      /* webpackChunkName: 'chunk-todayResultSliderHP' */
      '../../components/todayResults/slider'
    );

    todayResultsSlider(sliderElement);
    window.addEventListener('resize', () => todayResultsSlider(sliderElement));
  }
};

export const previewMatchesListVideoSliderInit = async () => {
  const sliderElements: NodeListOf<HTMLDivElement> = document.querySelectorAll(
    '.match-oveview-video-list'
  );

  if (sliderElements && sliderElements.length) {
    const { previewMatchesListVideoSlider } = await import(
      /* webpackChunkName: 'chunk-previewMatchesListVideoSlider' */
      '../../components/sportmod/preview-matches-list-video/slider'
    );

    previewMatchesListVideoSlider(sliderElements);
    window.addEventListener('resize', () => previewMatchesListVideoSlider(sliderElements));
  }
};

export const headerMenuFlat = async () => {
  const header = document.querySelector('header') as HTMLDivElement | null;
  if (header) {
    const { Header } = await import(
      /* webpackChunkName: 'chunk-headermenuflat' */
      '../../box/header/HeaderMenuFlat'
    );
    Header(header);
  }
};

// Zobrazení a skrytí photo credit popisku
export const infoToggle = async (): Promise<void> => {
  const triggerElements = Array.from(
    document.querySelectorAll<HTMLElement>('[data-info-toggle-trigger]')
  );

  if (triggerElements.length > 0) {
    const { default: InfoToggle } = await import(
      /* webpackChunkName: 'default/info-toggle' */
      '@featuresIsport/infoToggle'
    );

    triggerElements.forEach(InfoToggle);
  }
};

// TABS
export const tabs = async () => {
  const tabsSelectors = Array.from(document.querySelectorAll('[data-tabs]')) as HTMLDivElement[];

  if (tabsSelectors.length > 0) {
    const { Tabs } = await import(
      /* webpackChunkName: 'default/tabs' */
      '@featuresIsport/tabs'
    );

    for (const tabsSelector of tabsSelectors) {
      if (tabsSelector instanceof HTMLDivElement) {
        Tabs(tabsSelector);
      }
    }
  }
};

export const dayResultDatepicker = async () => {
  const datepickerCalendarDropdown: HTMLDivElement | null = document.querySelector(
    '[data-sportmod-day-result-datepicker]'
  );

  if (datepickerCalendarDropdown) {
    const { sportmodDayResultDatepicker } = await import(
      /* webpackChunkName: 'chunk-sportmodDayResultDatepicker' */
      '../../components/sportmod/day-result-datepicker/datepicker'
    );

    sportmodDayResultDatepicker(datepickerCalendarDropdown);
  }
};

export const ohSportPicker = async () => {
  const sportPickerDropdown: HTMLDivElement | null = document.querySelector(
    '[data-sportmod-oh-sport-picker]'
  );

  if (sportPickerDropdown) {
    const { sportmodSportPicker } = await import(
      /* webpackChunkName: 'chunk-sportmodOhSportPicker' */
      '../../components/sportmod/oh-sport-picker/ohSportPicker'
    );

    sportmodSportPicker(sportPickerDropdown);
  }
};

export const matchesUpdates = async () => {
  const matchesWrappers = Array.from(
    document.querySelectorAll('[data-matches-auto-update]')
  ) as HTMLDivElement[];

  if (matchesWrappers.length === 0) {
    return;
  }

  const { initAllMatchesUpdates } = await import(
    /* webpackChunkName: 'chunk-sportmod-live-match-websocket-updater' */
    '../../components/sportmod/live-match-websocket-updater/index'
  );

  for (const wrapper of matchesWrappers) {
    initAllMatchesUpdates(wrapper);
  }
};

export const matchDetailPageUpdates = async () => {
  const matchesWrapper = document.querySelector(
    '[data-match-detail-page-auto-update]'
  ) as HTMLDivElement;

  if (!matchesWrapper) {
    return;
  }

  const { initMatchDetailPageUpdates } = await import(
    /* webpackChunkName: 'chunk-sportmod-live-match-detail-page-websocket-updater' */
    '../../components/sportmod/live-match-websocket-updater/index'
  );

  initMatchDetailPageUpdates(matchesWrapper);
};

/**
 * Funkce pro načtení dat zápasů pro jednotlivé kola/fáze u konkrétní ligy.
 * Např. Aktualizace zápasů kola/fáze po kliknutí na vybrané kolo z dropdown menu.
 *  - použito na isport.blesk.cz/1-liga
 *  - zobrazuje zápasy kola - 1.kolo, 2.kolo, 3.kolo, atd.
 */
export const leaguePhaseReloader = async (): Promise<void> => {
  const matchesWrappers = Array.from(
    document.querySelectorAll<HTMLElement>('[data-matches-phase-reloader]')
  );

  if (matchesWrappers.length === 0) {
    return;
  }

  const { initLeaguePhaseReloader } = await import(
    /* webpackChunkName: 'chunk-sportmod-league-phase-reloader' */
    '../../components/sportmod/league-phase-reloader/index'
  );

  for (const wrapper of matchesWrappers) {
    const hiddenContent = wrapper.closest<HTMLElement>('[data-content-chip-menu-item-id][hidden]');

    if (hiddenContent) {
      continue;
    }

    initLeaguePhaseReloader(wrapper);
  }
};

/**
 * Funkce na načtení dat zápasů včetně tabulky pro jednotlivé podligy.
 * Např. Aktualizace dat podligy s tabulkou zápasů po kliknutí na vybranou `podligu“ z menu - ajaxem
 *  - použito na isport.blesk.cz/1-liga - nástavba část.
 *  - futbal 1 liga má podligy "skupina o titul, Baráž, a iné"
 */
export const matchesWithTableSubleagueReloader = async () => {
  const matchesWrapper = document.querySelector(
    '[data-matches-with-table-subleague-reloader]'
  ) as HTMLDivElement;

  if (!matchesWrapper) {
    return;
  }

  const { initMatchesWithTableSubleagueReloader } = await import(
    /* webpackChunkName: 'chunk-sportmod-matches-with-table-subleague-reloader' */
    '../../components/sportmod/matches-with-table-reloader/index'
  );

  initMatchesWithTableSubleagueReloader(matchesWrapper);
};

/**
 * Funkce na načtení dat zápasů včetně tabulky pro jednotlivé fáze ligy.
 * Např. Načtení dat fáze s tabulkou zápasů po kliknutí na vybraný `fázu“ z menu - ajaxem
 *  - použito na isport.blesk.cz/ms-hokej-2025
 *  - liga MS v hokeji má fáze: skupina A, skupin B a play-off"
 */
export const matchesWithTablePhaseReloader = async () => {
  const matchesWrappers = Array.from(
    document.querySelectorAll('[data-matches-with-table-phase-reloader]')
  ) as HTMLDivElement[];

  if (matchesWrappers.length === 0) {
    return;
  }

  const { initMatchesWithTablePhaseReloader } = await import(
    /* webpackChunkName: 'chunk-sportmod-matches-with-table-phase-reloader' */
    '../../components/sportmod/matches-with-table-reloader/index'
  );

  for (const wrapper of matchesWrappers) {
    initMatchesWithTablePhaseReloader(wrapper);
  }
};

/**
 * Funkce pro přepínání jednotlivých podlig v tabovém chip menu.
 *
 * Např. fotbalová 1. liga má podligy:
 * Skupina o titul, skupina o záchranu, baráž a další.
 */
export const matchesWithTableSubleagueTabsContent = async (): Promise<void> => {
  const subleaguesWrappers = document.querySelectorAll<HTMLElement>(
    '[data-matches-with-table-subleague-chip-init]'
  );

  if (!subleaguesWrappers.length) {
    return;
  }

  const [{ initTabsChipMenu }, { initAllMatchesUpdates }] = await Promise.all([
    import(
      /* webpackChunkName: 'chunk-sportmod-matches-with-table-subleague-tabs-content' */
      '../../components/sportmod/matches-with-table-reloader/index'
    ),
    import(
      /* webpackChunkName: 'chunk-sportmod-live-match-websocket-updater-tabs-content' */
      '../../components/sportmod/live-match-websocket-updater/index'
    ),
  ]);

  subleaguesWrappers.forEach((subleaguesWrapper) => {
    /**
     * Inicializuje přepínání podlig v chip menu.
     *
     * Po změně aktivní podligy zobrazí odpovídající obsah
     * a nastaví WebSocket aktualizace pouze pro právě aktivní podligu.
     */
    initTabsChipMenu(subleaguesWrapper, {
      onContentChange: (activeContent) => {
        initAllMatchesUpdates(activeContent);
      },
    });
  });
};

/**
 * Funkce pro zobrazování/skrývaní zápasů týmu v sekcích detail týmů
 */
export const teamMatchesToggle = async () => {
  const teamMatchesWrapper = document.querySelector(
    '[data-detail-team-leagues-toggle]'
  ) as HTMLDivElement;

  if (!teamMatchesWrapper) {
    return;
  }

  const { initTeamMatchesToggle } = await import(
    /* webpackChunkName: 'chunk-sportmod-team-matches-toggle' */
    '../../components/sportmod/detail-team/index'
  );

  initTeamMatchesToggle(teamMatchesWrapper);
};

/**
 * Inicializace dynamického načtení obsahu kategorie.
 */
export const categoryContentLoader = async () => {
  const container = document.querySelector('[data-content-loader]') as HTMLDivElement;

  if (!container) {
    return;
  }

  const content = container.querySelector('[data-category-content]') as HTMLDivElement;

  if (!content) {
    return;
  }

  // Získání hodnoty kategorie nebo seznamu kategorií z atributu data
  const categoryValue = content.dataset.categoryContent;

  if (!categoryValue) {
    return;
  }

  const { initCategoryContent, fetchCategoryContent } = await import(
    /* webpackChunkName: 'chunk-category-content-loader' */
    '../../box/contentTop/initCategoryContent'
  );

  await initCategoryContent(content, categoryValue, fetchCategoryContent);
};

/**
 * Inicializace dynamického načtení nejčtenějších článků podle zadaných kategorií.
 */
export const categoryMostReadContentLoader = async () => {
  const topFeed = document.querySelector('[data-top-feed-element]') as HTMLDivElement;

  if (!topFeed) {
    return;
  }

  const container = topFeed.querySelector('[data-category-most-read-content]') as HTMLDivElement;

  if (!container) {
    return;
  }

  // Získání hodnoty kategorie nebo seznamu kategorií z atributu data
  const categoryValue = container.dataset.categoryMostReadContent;

  if (!categoryValue) {
    return;
  }

  const { initCategoryContent, fetchMostReadCategory } = await import(
    /* webpackChunkName: 'chunk-category-mostread-content-loader' */
    '../../box/contentTop/initCategoryContent'
  );

  await initCategoryContent(container, categoryValue, fetchMostReadCategory);
};

export const topFeedResponsiveBehavior = async () => {
  const topFeed = document.querySelector('[data-top-feed-element]') as HTMLDivElement;

  if (!topFeed) {
    return;
  }

  const { initTopFeedResponsive } = await import(
    /* webpackChunkName: 'chunk-top-feed-responsive-behavior' */
    '../../components/topFeed/index'
  );

  initTopFeedResponsive();
};

/**
 * Funkce pro inicializaci načítání dalších videí v detailu týmu
 */
export const teamVideosLoadMore = async (): Promise<void> => {
  const videosWrapper = document.querySelector('[data-detail-team-videos]') as HTMLElement;

  if (!videosWrapper) {
    return;
  }

  const { initTeamVideosLoadMore } = await import(
    /* webpackChunkName: 'chunk-sportmod-team-videos-load-more' */
    '../../components/sportmod/detail-team/initTeamVideosLoadMore'
  );

  initTeamVideosLoadMore(videosWrapper);
};

/**
 * Vypis programu OH – homepage
 */
export const programOhHp = async () => {
  const wrapper = document.querySelector<HTMLDivElement>('[data-program-oh-hp]');

  if (!wrapper) {
    return;
  }

  const { initProgramOhHp } = await import(
    /* webpackChunkName: 'chunk-sportmod-program-oh-hp' */
    '../../components/sportmod/programOhHp/index'
  );

  initProgramOhHp(wrapper);
};

/**
 * Inicializace sbalování a rozbalování obsahu.
 */
export const contentToggle = async () => {
  const containers = document.querySelectorAll<HTMLElement>('[data-toggle-content-init]');

  if (!containers.length) {
    return;
  }

  const { toggleContent } = await import(
    /* webpackChunkName: 'chunk-toggle-content' */
    '../../components/toggle-content/toggle-content'
  );

  // Inicializace všech toggle boxů na stránce
  containers.forEach((containerElement) => {
    const heightValue = Number(containerElement.dataset.toggleContentHeight);

    const collapsedHeight = Number.isFinite(heightValue) && heightValue > 0 ? heightValue : 270;

    toggleContent({
      containerElement,
      collapsedHeight,
    });
  });
};

/**
 * Inicializace filtru výsledků podle sportu.
 */
export const sportResultsFilter = async () => {
  const containers = document.querySelectorAll<HTMLElement>('[data-sports-filter]');

  if (!containers.length) {
    return;
  }

  const { sportsFilter } = await import(
    /* webpackChunkName: 'chunk-sport-results-filter' */
    '../../components/sportmod/sports-filter/sportsFilter'
  );

  // Inicializace všech sportovních filtrů na stránce
  containers.forEach((containerElement) => {
    sportsFilter(containerElement);
  });
};
